export default {
  cancel: 'Cancel',
  bind: 'Binding'
}